require('../../modules/es.object.get-own-property-descriptors');

module.exports = require('../../internals/path').Object.getOwnPropertyDescriptors;
